import _ from 'lodash';

import { SmartenitPlugin } from '../smartenit-plugin';

export abstract class InOutInputPlugin extends SmartenitPlugin {
  public findMetaInput(): any {
    const inputs: any[] = _.get(this.device, 'meta.inputs', []);
    return inputs.find(
      (i) =>
        i.componentId === this.componentId && i.processor === this.processorName
    );
  }
}
